import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { StorageService } from '../services/storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUser, IClienteService, IOtp } from '../interfaces';
import { CartService } from '../services/cart.service';
import { dbLocalIndex } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AutService {

  private currentUserSubject: BehaviorSubject<IUser>;
  public currentUser: Observable<IUser>;
  private refreshTokenTimeout;

  constructor( private http: HttpClient,
               private storageService: StorageService,
               private cartService: CartService) {

      this.currentUserSubject = new BehaviorSubject<IUser>( this.storageService.getUserSession() );
      this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): IUser {
    return this.currentUserSubject.value;
  }

  verificarTelefono( telefono: string ) {
    return this.http.post<IClienteService>( `${ environment.api }aut/verificartelefono`, { telefono } );
  }

  IniciarSesion( telefono: string, password: string ) {
    return this.http.post<IUser>(`${ environment.api }aut/login`, { telefono, password } ).pipe(
      map( (data: IUser) => {
        this.storageService.saveUserSession(data);
        this.currentUserSubject.next(data);
        this.startRefreshTokenTimer();
        return data.token;
      })
    );
  }

  IniciarSesionInvitado() {
    return this.http.post<IUser>(`${ environment.api }aut/loginInvitado`, null).pipe(
      map( (data: IUser) => {
        this.storageService.saveUserSession(data);
        this.currentUserSubject.next(data);
        this.startRefreshTokenTimer();
        return data;
      })
    );
  }

  generarOTP( idUser: number ) {
    return this.http.post<IOtp>( `${ environment.api }aut/otpactivarusuario`, { id: idUser } ).pipe(
      map( (data: any) => {
        if (data.ok) {
          this.storageService.set(dbLocalIndex.otp, data);
        }
        return data;
      })
    );
  }

  generarOTPCambioClave( idUser: number ) {
        return this.http.post<IOtp>( `${ environment.api }aut/otpcambioclave`, { id: idUser } ).pipe(
            map( (data: any) => {
                if (data.ok) {
                    this.storageService.set(dbLocalIndex.otp, data);
                }
                return data;
            })
        );
  }

  validarOTP( obj: any, login: boolean ) {
    return this.http.post<IUser>( `${ environment.api }aut/verificarotp`, obj ).pipe(
      map( (data: any) => {
        if (data.ok) {
            if ( login ) {
              this.storageService.saveUserSession(data);
              this.currentUserSubject.next(data);
              this.startRefreshTokenTimer();
            }
            // Eliminamos los registros previos
            this.storageService.delete(dbLocalIndex.otp).finally();
            this.storageService.delete(dbLocalIndex.userCheck).finally();
            this.storageService.delete(dbLocalIndex.userTemp).finally();
        }
        return data;
      })
    );
  }

  async CerrarSesion() {
    // remove user from local storage to log user out
    // await this.storageService.deleteUser();
    // await this.storageService.clean();

    // Limpiamos el observable y detenemos el refresh token
    // this.currentUserSubject.next(null);
    this.stopRefreshTokenTimer();

    // Volvemos a iniciar sesión como invitado
    this.IniciarSesionInvitado().subscribe(()=>{
        // Limpiamos el carrito
        this.storageService.resetCarrito();
        this.cartService.resetCart();
    });
  }

  refreshToken() {
      // Verificamos que exista una session
      if ( !this.currentUserSubject.value.ok ) {
          return this.IniciarSesionInvitado();
      }

      // Si existe solamente renovamos el token
      return this.http.post<any>(`${environment.api}aut/renew`, this.currentUserValue)
          .pipe(map((user) => {
              this.storageService.saveUserSession(user);
              this.currentUserSubject.next(user);
              // this.startRefreshTokenTimer();
              return user;
          }));
  }

  // helper methods
  private startRefreshTokenTimer() {
      // parse json object from base64 encoded jwt token
      const jwtToken = JSON.parse(atob(this.currentUserSubject.value.token.split('.')[1]));

      // set a timeout to refresh the token a minute before it expires
      const expires = new Date(jwtToken.exp * 1000);
      // tope de setTimeout (int32): con más, el navegador lo dispara al instante (JWT de 90 días)
      const timeout = Math.min(expires.getTime() - Date.now() - (60 * 1000), 2147483647);
      this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
      clearTimeout(this.refreshTokenTimeout);
  }
}
